export default "__VITE_ASSET__Ba$QFgRO__"